module.exports = __webpack_public_path__ + "static/media/bigticket-app_2screen.8dc0bf7d.png";